export default import.meta.ROLLUP_FILE_URL_i3GNk602QQG3nNNcpvfidA